
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apparel",
      function () {
        return require("private-next-pages/apparel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apparel"])
      });
    }
  